import { render, staticRenderFns } from "./SizeInformationParameterView.vue?vue&type=template&id=0fc94d66&"
import script from "./SizeInformationParameterView.vue?vue&type=script&lang=js&"
export * from "./SizeInformationParameterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports